import { Injectable } from '@nestjs/common';
import { SoProductionDTO } from '../dto/so-production.dto';
import { SoProduction } from '../entities/so-production.entity';

@Injectable()
export class SoProductionAdapter {
  /** 
   * 
   * @param currenciesDto 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(  soProductionDto: SoProductionDTO,  isUpdate: boolean = false ): SoProduction {
    const soProduction = new SoProduction();
    soProduction.soProductionId=soProductionDto.soProductionId;
    soProduction.saleOrderId=soProductionDto.saleOrderId;
    soProduction.saleOrderItemId=soProductionDto.saleOrderItemId;
    soProduction.inputQuantity=soProductionDto.inputQuantity;
    soProduction.outputQuantity=soProductionDto.outputQuantity;
    soProduction.type=soProductionDto.type;
    soProduction.versionFlag=soProductionDto.versionFlag;
    soProduction.lotNumber=soProductionDto.lotNumber;
    if (isUpdate) {
        soProduction.updatedUser = soProductionDto.updatedUser;
        soProduction.updatedAt = soProductionDto.updatedAt;

    } else {
        soProduction.createdUser = soProductionDto.createdUser;
        soProduction.createdAt = soProductionDto.createdAt;

    }
   return soProduction;
  }
  public convertEntityToDto(soProductionObject: SoProduction): SoProductionDTO {
    const soProductionDTO= new SoProductionDTO;
    soProductionDTO.soProductionId=soProductionObject.soProductionId;
    soProductionDTO.lotNumber=soProductionObject.lotNumber;
    soProductionDTO.type = soProductionObject.type;
    soProductionDTO.saleOrderId = soProductionObject.saleOrderId;
    soProductionDTO.saleOrderItemId = soProductionObject.saleOrderItemId;
    soProductionDTO.inputQuantity = soProductionObject.inputQuantity;
    soProductionDTO.outputQuantity = soProductionObject.outputQuantity;
    soProductionDTO.createdAt = soProductionObject.createdAt;
    soProductionDTO.updatedAt = soProductionObject.updatedAt;
    soProductionDTO.createdUser = soProductionObject.createdUser;
    soProductionDTO.updatedUser = soProductionObject.updatedUser;
    soProductionDTO.versionFlag = soProductionObject.versionFlag;
    return soProductionDTO;
  }
}
